module.exports = __webpack_public_path__ + "static/brandobaris-symbol-DND3_FnP-72a6c7bba7f8fcbf6407b40f2ad037ea.jpg";